import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import { SxProps, Theme } from '@mui/material/styles';

interface InfoTooltipProps {
  text: string;
  sx?: SxProps<Theme>;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, sx }) => {
  return (
    <Tooltip title={text} arrow>
      <IconButton size="small" color="primary" sx={{ ml: 1, ...sx }}>
        <InfoIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
